import {Action} from '@arena/shared';

/** A group of the sound bank and its playback rate (below 1: deeper and slower). */
export type Cue={readonly group:string;readonly rate?:number};
const cue=(group:string,rate?:number):Cue=>({group,rate});

/** The sound of a summoned servant, by kind: its arrival and its attacks. */
export function creatureSound(kind:string):Cue {
  return kind==='migo'?cue('insects'):kind==='hoplite'?cue('metal',.8):cue('slime');
}

/** A zone on the ground, heard where it appears: Virgilio's roots, Kafka's swarm, Gandhi's salt, Cleopatra's bath. */
export function zoneSound(kind:string):Cue|undefined {
  return kind==='roots'?cue('wood',.7):kind==='swarm'?cue('insects',1.15):kind==='salt'?cue('salt',.8):kind==='milk'?cue('drink',.8):undefined;
}

export function moveSound(champion:string,action:number,transformed=false):Cue {
  if(action===Action.Throw)return cue('whip');
  if(champion==='kafka'&&transformed)return cue('insects');
  const spells:Record<string,readonly [Cue,Cue,Cue]>={
    // Virgilio's ghostly call (the roots sound where they grow), a Malebranche bursting out of Hell.
    dante:[cue('magic',.75),cue('fire',1.15),cue('rumble')],
    gandhi:[cue('whip'),cue('salt'),cue('magic')],
    mussolini:[cue('shutter'),cue('wood'),cue('engine')],
    // His gesture; the swarm is heard where it lands.
    kafka:[cue('swing',1.1),cue('drink'),cue('insects')],
    lovecraft:[cue('magic'),cue('slime'),cue('rumble')],
    // The phalanx raises its bronze shields.
    auramennone:[cue('metal',.7),cue('magic'),cue('rumble')],
    // The asp hisses off, the milk pours, the nose enchants.
    cleopatra:[cue('slime',1.35),cue('splash',.75),cue('magic',1.3)],
    // The brioche tossed, the wig pulled down with a swish, the hairpin out and away.
    antonietta:[cue('swing',1.25),cue('swing',.7),cue('whip',.8)],
    // The pole driven into the ground, the rush, the whistle and the gallop.
    giovanna:[cue('wood',.8),cue('whip',1.1),cue('rumble',1.2)],
  };
  const special=action===Action.Special1?0:action===Action.Special2?1:action===Action.SuperSlam?2:-1;
  if(special===0||special===1||special===2)return spells[champion]?.[special]??cue('magic');
  if(champion==='mussolini'&&(action===Action.Light3||action===Action.AirAttack))return cue('gun');
  // Spear thrusts; the shield blows ring like bronze.
  if(champion==='auramennone')return action===Action.Light3||action===Action.DashAttack?cue('metal',.8):cue('whip',.85);
  // A quick open-hand slap; the golden sceptre swishes, lighter than a spear.
  if(champion==='cleopatra')return action===Action.Light1?cue('swing',1.35):cue('whip',1.15);
  // The lace parasol swishes; the wig comes down like a pillow on a hammer.
  if(champion==='antonietta')return action===Action.Light3?cue('swing',.8):cue('whip',1.3);
  // The sword rings like steel; the banner pole sweeps.
  if(champion==='giovanna')return action===Action.Light3?cue('swing',.85):cue('metal',1.25);
  // Dante's tome is heavier than Lovecraft's manuscript.
  return champion==='dante'?cue('book',.85):champion==='kafka'?cue('splash'):champion==='lovecraft'?cue('book'):cue('swing');
}
